<template>
<div>
    <template v-if="popYn === 'N'">    
        <base-header v-once pageName="영업활동계획서" :prevBtnShow="true"></base-header>
    </template>
    <template v-else>
        <base-header v-once pageName="영업활동계획서" :prevBtnShow="true" :popup="true"></base-header>
    </template>
    <section id="wrap">
        <h3 class="bsnsAcpln-tit">{{planYr}}년 {{planMn}}월 영업활동계획</h3>
        <div class="bsnsAcpln-write">
            <div>
                <h6>개인 실적 목표</h6>
                <span><em>{{Number(cmclGoalAmt.replaceAll(',' , '')) + Number(mmbsGoalAmt.replaceAll(',' , '')) + Number(frpsGoalAmt.replaceAll(',' , '')) + Number(etcGoalAmt.replaceAll(',' , ''))| numFormat}}</em>만원</span>
                <ul>
                    <li>

                        <strong>전집</strong>
                        <p>
                            <input type="tel" v-model="cmclGoalAmt"><em>만원</em><template v-if="stat === 'C'"> /
                            <input type="text" name="" id="" v-bind:value="orcpCmclGoalAmt | numFormat" readonly><em>만원</em> </template>
                        </p>
                    </li>
                    <li>
                        <strong>멤버십</strong>
                        <p>
                            <input type="tel" name="" id="" v-model="mmbsGoalAmt"><em>만원</em><template v-if="stat === 'C'"> /
                            <input type="text" name="" id="" v-bind:value="orcpMmbsGoalAmt | numFormat" readonly><em>만원</em> </template>
                        </p>
                    </li>
                    <li>
                        <strong>프리패스</strong>
                        <p>
                            <input type="tel" name="" id="" v-model="frpsGoalAmt"><em>만원</em><template v-if="stat === 'C'"> /
                            <input type="text" name="" id="" v-bind:value="orcpFrpsGoalAmt | numFormat" readonly><em>만원</em> </template>
                        </p>
                    </li>
                    <li>
                        <strong>기타(잡지등)</strong>
                        <p>
                            <input type="tel" name="" id="" v-model="etcGoalAmt"><em>만원</em><template v-if="stat === 'C'"> /
                            <input type="text" name="" id="" v-bind:value="orcpEtcGoalAmt | numFormat" readonly><em>만원</em> </template>
                        </p>
                    </li>
                </ul>
            </div>
            <div>
                <h6>활동 목표</h6>
                <ul class="flex">
                    <li>
                        <strong>소스</strong>
                        <p><input type="number" :disabled="disableChk()" v-model="srcGoalCscnt"><em>건</em></p>
                    </li>
                    <li>
                        <strong>진단서비스</strong>
                        <p><input type="number" :disabled="disableChk()" v-model="dgnssrvcGoalCscnt"><em>건</em></p>
                    </li>
                    <!-- <li>
                        <strong>리크루팅</strong>
                        <p><input type="number" :disabled="disableChk()" v-model="rcrtGoalCscnt"><em>건</em></p>
                    </li> -->
                </ul>
            </div>
            <div>
                <h6>상담 목표</h6>
                <ul class="flex">
                    <li>
                        <strong>기존상담</strong>
                        <p><input type="number" :disabled="disableChk()" v-model="exsnConsCscnt"><em>건</em></p>
                    </li>
                    <li>
                        <strong>신규상담</strong>
                        <p><input type="number" :disabled="disableChk()" v-model="newConsCscnt"><em>건</em></p>
                    </li>
                </ul>
            </div>            
        </div>
        <dl class="bsnsAcpln-write">
            <dt>
                구간 마감
                <p>* 구간 실적은 자동비율로 노출됩니다.</p>
            </dt>
            <dd>
                <p>단위(만원)</p>
                <table>
                    <thead>
                        <tr>
                            <th>마감</th>
                            <th>목표</th>
                            <th>전집</th>
                            <th>멤버십</th>
                            <th>프리패스</th>
                            <th>기타</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1영업일</td>
                            <td>{{Math.floor(beginPeriod*100)+'%'}}</td>
                            <td>{{Math.floor((cmclGoalAmt.replaceAll(',' , '')) * beginPeriod) | numFormat}}</td>
                            <td>{{Math.floor((mmbsGoalAmt.replaceAll(',' , '')) * beginPeriod) | numFormat}}</td>
                            <td>{{Math.floor((frpsGoalAmt.replaceAll(',' , '')) * beginPeriod) | numFormat}}</td>
                            <td>{{Math.floor((etcGoalAmt.replaceAll(',' , ''))  * beginPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>1구간</td>
                            <td>{{Math.floor(firstPeriod*100)+'%'}}</td>
                            <td>{{Math.floor((cmclGoalAmt.replaceAll(',' , '')) * firstPeriod) | numFormat}}</td>
                            <td>{{Math.floor((mmbsGoalAmt.replaceAll(',' , '')) * firstPeriod) | numFormat}}</td>
                            <td>{{Math.floor((frpsGoalAmt.replaceAll(',' , '')) * firstPeriod) | numFormat}}</td>
                            <td>{{Math.floor((etcGoalAmt.replaceAll(',' , ''))  * firstPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>2구간</td>
                            <td>{{Math.floor(secondPeriod*100)+'%'}}</td>
                            <td>{{Math.floor((cmclGoalAmt.replaceAll(',' , '')) * secondPeriod) | numFormat}}</td>
                            <td>{{Math.floor((mmbsGoalAmt.replaceAll(',' , '')) * secondPeriod) | numFormat}}</td>
                            <td>{{Math.floor((frpsGoalAmt.replaceAll(',' , '')) * secondPeriod) | numFormat}}</td>
                            <td>{{Math.floor((etcGoalAmt.replaceAll(',' , ''))  * secondPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>3구간</td>
                            <td>{{Math.floor(thridPeriod*100)+'%'}}</td>
                            <td>{{Math.floor((cmclGoalAmt.replaceAll(',' , '')) * thridPeriod) | numFormat}}</td>
                            <td>{{Math.floor((mmbsGoalAmt.replaceAll(',' , '')) * thridPeriod) | numFormat}}</td>
                            <td>{{Math.floor((frpsGoalAmt.replaceAll(',' , '')) * thridPeriod) | numFormat}}</td>
                            <td>{{Math.floor((etcGoalAmt.replaceAll(',' , ''))  * thridPeriod) | numFormat}}</td>
                        </tr>
                        <tr>
                            <td>월마감</td>
                            <td>{{Math.floor(monthEnd*100)+'%'}}</td>
                            <td>{{Math.floor((cmclGoalAmt.replaceAll(',' , '')) * monthEnd) | numFormat}}</td>
                            <td>{{Math.floor((mmbsGoalAmt.replaceAll(',' , '')) * monthEnd) | numFormat}}</td>
                            <td>{{Math.floor((frpsGoalAmt.replaceAll(',' , '')) * monthEnd) | numFormat}}</td>
                            <td>{{Math.floor((etcGoalAmt.replaceAll(',' , ''))  * monthEnd) | numFormat}}</td>
                        </tr>
                    </tbody>
                </table>
            </dd>
            <dt>기타 보고사항</dt>
            <dd class="memo">
                <textarea name="" id="" placeholder="기타 내용을 입력해주세요." v-model="memo"></textarea>
                <span><em>{{txtSize}}</em>/1000Byte</span>
            </dd>
        </dl>
    </section>
     <div class="btnWrap">
        <button type="button" class="black" @click="onCancel">취소</button>
        <button type="button" class="red" @click="saveBsnPln">{{saveTxt}}</button>
    </div>
</div>
</template>

<script>

export default {
  data() {
		return{
			sqno : this.$route.query.sqno,
            planYr : this.$route.query.planYr,
            planMn : this.$route.query.planMn,
            stat : '',
			txtSize : 0,
			saveTxt : '등록',

            amtSum : '',
            cmclGoalAmt : '',

            mmbsGoalAmt : '',
            frpsGoalAmt : '',
            etcGoalAmt : '',
            srcGoalCscnt : '',
            dgnssrvcGoalCscnt : '',
            rcrtGoalCscnt : '',
            exsnConsCscnt : '',
            newConsCscnt : '',

            orcpCmclGoalAmt : '',
            orcpMmbsGoalAmt : '',
            orcpFrpsGoalAmt : '',
            orcpEtcGoalAmt : '',
            orcpSrcGoalCscnt : '',
            orcpDgnssrvcGoalCscnt : '',
            orcpRcrtGoalCscnt : '',
            orcpExsnConsCscnt : '',
            orcpNewConsCscnt : '',

            memo : this.$route.query.memo,

            beginPeriod : 0,
            firstPeriod : 0,
            secondPeriod : 0,
            thridPeriod : 0,
            monthEnd : 0,
            popYn: 'Y'

		};
  },
  watch: {
		memo(newVal, oldVal){
			var byte = 0;

			for (var i=0; i<newVal.length; ++i) {
				(newVal.charCodeAt(i) > 127) ? byte += 2 : byte++ ;
			}

			if(byte > 1000)
				this.memo = oldVal;
			else
				this.txtSize = byte;
		},
  
        cmclGoalAmt: function(newValue) {
        var result = newValue.replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.cmclGoalAmt = result);
        },
        mmbsGoalAmt: function(newValue) {
        var result = newValue.replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.mmbsGoalAmt = result);
        },
        frpsGoalAmt: function(newValue) {
        var result = newValue.replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.frpsGoalAmt = result);
        },
        etcGoalAmt: function(newValue) {
        var result = newValue.replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.etcGoalAmt = result);
        }                        

	},
  methods: {

    close: function() {
      if(confirm('취소 하시겠습니까?')) {
        this.$router.push('/mypage/bsnPlnList'); 
      }
    },

    onCancel: function() {
      if(confirm('취소 하시겠습니까?')) {
        this.$router.push('/mypage/bsnPlnList'); 
      }
    },

    disableChk : function(){
       if(this.sqno == "" || this.stat == "R") {
         return false;
       } else {
         return true;
       }

    } , 
    saveBsnPln: function(){
        if(!this.cmclGoalAmt || !this.cmclGoalAmt.trim()){
            alert("전집 실적을 입력해주세요.");
            return false;
        }
        if(!this.mmbsGoalAmt || !this.mmbsGoalAmt.trim()){
            alert("멤버쉽 실적을 입력해주세요.");
            return false;
        }  
        if(!this.frpsGoalAmt || !this.frpsGoalAmt.trim()){
            alert("프리패스 실적을 입력해주세요.");
            return false;
        }         
        if(!this.etcGoalAmt || !this.etcGoalAmt.trim()){
            alert("기타 실적을 입력해주세요.");
            return false;
        }          
        if(!this.srcGoalCscnt || !this.srcGoalCscnt.trim()){
            alert("소스 실적을 입력해주세요.");
            return false;
        } 
        if(!this.dgnssrvcGoalCscnt || !this.dgnssrvcGoalCscnt.trim()){
            alert("진단서비스 실적을 입력해주세요.");
            return false;
        }
        // if(!this.rcrtGoalCscnt || !this.rcrtGoalCscnt.trim()){
        //     alert("리크루팅 실적을 입력해주세요.");
        //     return false;
        // } 
        if(!this.exsnConsCscnt || !this.exsnConsCscnt.trim()){
            alert("기존상담 실적을 입력해주세요.");
            return false;
        }                             
        if(!this.newConsCscnt || !this.newConsCscnt.trim()){
            alert("신규상담 실적을 입력해주세요.");
            return false;
        } 
        if(confirm("영업활동계획을 "+this.saveTxt+"하시겠습니까?")){
            var that = this;
            var parameters = {
                sqno : this.sqno,
                stat : this.stat,
                planYrmn : this.planYr+this.planMn,
                cmclGoalAmt : this.cmclGoalAmt.replaceAll(',' , ''),
                mmbsGoalAmt : this.mmbsGoalAmt.replaceAll(',' , ''),
                frpsGoalAmt : this.frpsGoalAmt.replaceAll(',' , ''),
                etcGoalAmt : this.etcGoalAmt.replaceAll(',' , ''),
                srcGoalCscnt : this.srcGoalCscnt,
                dgnssrvcGoalCscnt : this.dgnssrvcGoalCscnt,
                rcrtGoalCscnt : this.rcrtGoalCscnt,
                exsnConsCscnt : this.exsnConsCscnt,
                newConsCscnt : this.newConsCscnt,
                memo : this.memo
            };
            this.$api.mypage
            .saveBsnPln(parameters)
            .then(function(data) {
                if(data && data > 0){
                    alert(that.saveTxt+"되었습니다.");

                    that.$router.push('/mypage/bsnPlnList'); 

                }else{
                    alert(that.saveTxt+"에 실패하였습니다.");
                }
            })
            .catch(function(error) {
                    alert(error.rtMsg);
            });
        }
    }

  },

created : function(){
    this.popYn = this.$route.query.popYn;

    if(this.sqno && this.stat ==='C'){
        this.saveTxt = '수정'
    }
        var that = this;
        var parameters = {
            sqno : this.sqno
        };
        this.$api.mypage
        .bsnPlnInfo(parameters)
        .then(function(data) {
            if(data){
                if(that.sqno) {
                    that.sqno = data.sqno;
                    that.stat = data.stat;
                    that.amtSum = data.amtSum;
                    that.userName = data.userName;
                    that.userId = data.userId;
                    that.pstn = data.pstn;
                    that.planYr = data.planYr;
                    that.planMn = data.planMn;
                    that.cmclGoalAmt = data.cmclGoalAmt;
                    that.mmbsGoalAmt = data.mmbsGoalAmt;
                    that.frpsGoalAmt = data.frpsGoalAmt;
                    that.etcGoalAmt = data.etcGoalAmt;
                    that.srcGoalCscnt = data.srcGoalCscnt;
                    that.dgnssrvcGoalCscnt = data.dgnssrvcGoalCscnt;
                    that.rcrtGoalCscnt = data.rcrtGoalCscnt;
                    that.exsnConsCscnt = data.exsnConsCscnt;
                    that.newConsCscnt = data.newConsCscnt;
                    that.orcpCmclGoalAmt = data.orcpCmclGoalAmt;
                    that.orcpMmbsGoalAmt = data.orcpMmbsGoalAmt;
                    that.orcpFrpsGoalAmt = data.orcpFrpsGoalAmt;
                    that.orcpEtcGoalAmt = data.orcpEtcGoalAmt;
                    that.orcpSrcGoalCscnt = data.orcpSrcGoalCscnt;
                    that.orcpDgnssrvcGoalCscnt = data.orcpDgnssrvcGoalCscnt;
                    that.orcpRcrtGoalCscnt = data.orcpRcrtGoalCscnt;
                    that.orcpExsnConsCscnt = data.orcpExsnConsCscnt;
                    that.orcpNewConsCscnt = data.orcpNewConsCscnt;
                    that.memo = data.memo;
                }
                that.beginPeriod = data.period[0].cdVl1; //1영업일
                that.firstPeriod = data.period[1].cdVl1; //1구간
                that.secondPeriod = data.period[2].cdVl1;//2구간
                that.thridPeriod = data.period[3].cdVl1; //3구간
                that.monthEnd = data.period[4].cdVl1;    //4구간
            
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    
},
    filters:{
        numFormat:function(num){
            if(num==0) return 0;

            var n = num+'';
            var reg = /(^[+-]?\d+)(\d{3})/;

            while (reg.test(n))
                n = n.replace(reg,'$1'+','+'$2');
            
            return n;
        }
    }
};
</script>